import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { gallery } from '../data/content';
const ease = [0.23, 1, 0.32, 1] as const;
export function Gallery() {
  const [index, setIndex] = useState(0);
  const total = gallery.length;
  const goTo = (next: number) => {
    setIndex((next + total) % total);
  };
  const handleKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (event.key === 'ArrowLeft') {
      event.preventDefault();
      goTo(index - 1);
    }
    if (event.key === 'ArrowRight') {
      event.preventDefault();
      goTo(index + 1);
    }
  };
  const current = gallery[index];
  return <section className="w-full bg-blue-900 py-16 text-white md:py-24" data-id="element-109" data-mp="2um540yk2gv05">
      <div className="mx-auto w-full max-w-5xl px-5 md:px-8" data-id="element-110" data-mp="2uktyouaz3f6x">
        <header className="mx-auto max-w-4xl text-center" data-id="element-111" data-mp="26vht04eutp9d">
          <p className="text-xs font-extrabold uppercase tracking-widest text-blue-200" data-id="element-112" data-mp="21yhmxti08mi9">
            Guarda le mappe dall'interno
          </p>
          <h2 className="mt-4 text-3xl font-extrabold leading-tight tracking-tight md:text-5xl" data-id="element-113" data-mp="rc1h8k0emkag">
            Ecco come viene analizzato ogni esercizio
          </h2>
        </header>

        <div role="group" aria-roledescription="carosello" aria-label="Galleria di mappe visive" tabIndex={0} onKeyDown={handleKeyDown} className="relative mt-12 rounded-2xl focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-blue-400" data-id="element-114" data-mp="113nqwbx3gbb3">
          <div className="overflow-hidden rounded-2xl" data-id="element-115" data-mp="dd1w3mc3onj1">
            <motion.div className="flex cursor-grab active:cursor-grabbing" animate={{
            x: `-${index * 100}%`
          }} transition={{
            duration: 0.3,
            ease
          }} drag="x" dragConstraints={{
            left: 0,
            right: 0
          }} dragElastic={0.12} onDragEnd={(_, info) => {
            if (info.offset.x < -60) goTo(index + 1);
            if (info.offset.x > 60) goTo(index - 1);
          }} data-id="element-116" data-mp="he3w45dud3m2">
              {gallery.map((item, itemIndex) => <figure key={item.title} className="w-full shrink-0" aria-hidden={itemIndex !== index} data-id="element-117" data-mp="3ptwqu6ii9o1n" data-mpi={itemIndex}>
                  <img src={item.image} alt={`Mappa visiva: ${item.title} — muscoli, piani anatomici ed errori più comuni`} className="pointer-events-none w-full rounded-2xl bg-white" draggable={false} loading="eager" decoding="async" data-id="element-118" data-mp="2qi963av0nfb" />
                </figure>)}
            </motion.div>
          </div>

          <button type="button" onClick={() => goTo(index - 1)} aria-label="Mappa precedente" className="absolute left-2 top-1/2 flex h-11 w-11 -translate-y-1/2 items-center justify-center rounded-full bg-white text-blue-800 shadow-lg transition-colors duration-150 ease-out hover:bg-blue-50 focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-blue-300 md:-left-5 md:h-12 md:w-12" data-id="element-119" data-mp="2sesngdizqove">
            <ChevronLeftIcon className="h-5 w-5" aria-hidden="true" data-id="element-120" data-mp="tyjs9m6ndehd" />
          </button>
          <button type="button" onClick={() => goTo(index + 1)} aria-label="Mappa successiva" className="absolute right-2 top-1/2 flex h-11 w-11 -translate-y-1/2 items-center justify-center rounded-full bg-white text-blue-800 shadow-lg transition-colors duration-150 ease-out hover:bg-blue-50 focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-blue-300 md:-right-5 md:h-12 md:w-12" data-id="element-121" data-mp="xzdfseg6gr9q">
            <ChevronRightIcon className="h-5 w-5" aria-hidden="true" data-id="element-122" data-mp="18kxrb9oop5b" />
          </button>
        </div>

        <div className="mx-auto mt-7 max-w-4xl text-center" aria-live="polite" data-id="element-123" data-mp="674mtkjkqh1w">
          <p className="text-xl font-extrabold tracking-tight md:text-2xl" data-id="element-124" data-mp="651ng9wj7bki">
            {current.title}
          </p>
          <p className="mt-2 text-blue-100" data-id="element-125" data-mp="gqku36b6hd54">{current.caption}</p>
        </div>

        <div className="mt-7 flex items-center justify-center gap-3" data-id="element-126" data-mp="gohtxtgba3mo">
          {gallery.map((item, itemIndex) => <button key={item.title} type="button" onClick={() => goTo(itemIndex)} aria-label={`Vedi ${item.title}`} aria-current={itemIndex === index} className={`h-2.5 rounded-full transition-[width,background-color] duration-200 ease-out focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-blue-400 ${itemIndex === index ? 'w-8 bg-white' : 'w-2.5 bg-white/35 hover:bg-white/60'}`} data-id="element-127" data-mp="7pwiei99bove" data-mpi={itemIndex} />)}
        </div>

        <p className="mt-6 text-center text-sm text-blue-200" data-id="element-128" data-mp="3g6rad2oinoup">
          Scorri o usa le frecce — {index + 1} di {total} mappe di esempio
        </p>
      </div>
    </section>;
}